import { useDispatch } from 'react-redux'
import { useState } from 'react'

import {
  actionCreateLink,
  actionFetchLinks,
  actionUpdateLink,
  actionFetchLink,
  actionResetLinks,
  actionSetLinks,
} from 'modules/Referral/ReferralLinks/actions'

export const useReferralLinks = () => {
  const [progress, setProgress] = useState(false)
  const [finished, setFinished] = useState(false)
  const [failed, setFailed] = useState(false)

  const dispatch = useDispatch()

  const fetchLinks = (props) =>
    new Promise((resolve, reject) => {
      setProgress(true)
      setFailed(false)
      setFinished(false)
      dispatch(actionFetchLinks({ ...props, meta: { resolve, reject } }))
    })
      .catch(() => setFailed(true))
      .finally(() => {
        setProgress(false)
        setFinished(true)
      })

  fetchLinks.progress = progress
  fetchLinks.finished = finished
  fetchLinks.failed = failed

  const updateLink = (props) =>
    new Promise((resolve, reject) =>
      dispatch(actionUpdateLink({ ...props, meta: { resolve, reject } })),
    )

  const createLink = (props) =>
    new Promise((resolve, reject) =>
      dispatch(actionCreateLink({ ...props, meta: { resolve, reject } })),
    )

  const fetchLink = (props) =>
    new Promise((resolve, reject) => {
      setProgress(true)
      setFailed(false)
      setFinished(false)
      return dispatch(actionFetchLink({ ...props, meta: { resolve, reject } }))
    })
      .catch(() => setFailed(true))
      .finally(() => {
        setProgress(false)
        setFinished(true)
      })

  fetchLink.progress = progress
  fetchLink.finished = finished
  fetchLink.failed = failed

  const setLinks = (props) => dispatch(actionSetLinks(props))

  const resetLinks = () => dispatch(actionResetLinks())

  return { fetchLinks, updateLink, createLink, fetchLink, resetLinks, setLinks }
}
